import React, { createContext, useContext, useState, ReactNode } from 'react';

interface WorkflowContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
}

const WorkflowContext = createContext<WorkflowContextType>({
  refreshTrigger: 0,
  triggerRefresh: () => {},
});

interface WorkflowProviderProps {
  children: ReactNode;
}

export const WorkflowProvider: React.FC<WorkflowProviderProps> = ({
  children,
}) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <WorkflowContext.Provider
      value={{
        refreshTrigger,
        triggerRefresh,
      }}
    >
      {children}
    </WorkflowContext.Provider>
  );
};

export const useWorkflowContext = () => {
  const context = useContext(WorkflowContext);
  if (!context) {
    throw new Error(
      'useWorkflowContext must be used within a WorkflowProvider'
    );
  }
  return context;
};
